module.exports = __webpack_public_path__ + "img/web_1.b4b0d89d.webp";